import { render, staticRenderFns } from "./JgpTabPanel.vue?vue&type=template&id=52d56b2a&"
import script from "./JgpTabPanel.vue?vue&type=script&lang=js&"
export * from "./JgpTabPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports